import React from "react";
import { Field } from "react-final-form";
import { CentsInput } from "../../../components/inputs/final_form/MoneyInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { atLeastOneFieldWithMoneyRequired, required } from "../../../util/validators";
import { AdministrateSelectInput } from "../../components/inputs/AdministrateSelectInput";

export const CptCodeListPriceForm = ({ handleSubmit, submitting }) => {
  return (
    <>
      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/cpt_codes.json"
        label="CPT Code"
        name="cptCodeId"
        required
        validate={required}
      />
      <Field component={CentsInput} validate={atLeastOneFieldWithMoneyRequired("medicarePercentage")} label="Price" name="priceCents" />
      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
